import { initStore } from '../../../common';
import { actions } from './actions';

export const loginStore = (): void => {
	const initialState = {
		slice: 'LOGIN',
		email: '',
		emailInvalid: false,
		password: '',
		errors: [],
		success: '',
		loginType: '',
	};

	initStore(actions, initialState);
};
